export const URL_API = (/development/gi).test(process.env.NODE_ENV) ?  'http://localhost/pedidosweb/api/' : '/api/';
export const URL_APLICATION = 'https://www.lanchar.com.br/';